import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Reveal, LineReveal } from "@/components/Reveal";
import { getBlog } from "@/lib/api";

const Blog = () => {
  const [posts, setPosts] = useState([]);
  useEffect(() => { getBlog().then(setPosts).catch(() => {}); }, []);

  return (
    <div data-testid="resources-page">
      <section className="relative pt-40 pb-16 border-b border-forest-700 overflow-hidden grain">
        <img src="/generated/resources.png" alt="Cascade meadow" className="absolute inset-0 w-full h-full object-cover opacity-90" />
        <div className="absolute inset-0 bg-ink/75" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
          <p className="text-xs uppercase tracking-[0.3em] text-golden-500 font-semibold mb-6">Resources</p>
          <h1 className="font-serif text-white text-5xl md:text-8xl leading-[0.95] tracking-tight">
            <LineReveal lines={["Field notes on", "Oregon HR."]} delay={0.2} />
          </h1>
          <p className="text-cream/90 text-lg max-w-xl mt-6">Plain-language guides on pay equity, fractional HR, and staying compliant in Oregon.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid md:grid-cols-3 gap-6">
          {posts.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 3) * 0.08}>
              <a href={`/resources/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group flex flex-col h-full bg-forest-900 border border-forest-700 rounded-sm overflow-hidden transition-all duration-300 hover:border-golden-500 hover:-translate-y-1">
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={p.cover} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center gap-3 mb-3 text-xs">
                    <span className="uppercase tracking-wider text-golden-500 font-semibold">{p.category}</span>
                    <span className="text-sage-400">{p.read_time}</span>
                  </div>
                  <h3 className="font-serif text-2xl text-sage-100 mb-3 leading-snug">{p.title}</h3>
                  <p className="text-sage-400 text-sm mb-6 flex-1">{p.excerpt}</p>
                  <span className="inline-flex items-center gap-2 text-sm font-semibold text-golden-500">Read <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" /></span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Blog;
